<template>
  <div class="news_content">
    <div class="news_content_box" v-for="(board,index) in boardData" :key="`news${board.wr_id}`"
         @click="goDetail(board.wr_id)">
      <img class="news_content_box_img" :src="returnImage(board)">
      <div class="news_content_box_text">{{ board.wr_subject }}</div>
    </div>
  </div>
</template>

<script>
import imageOption from "@/mixins/imageOption";

export default {
  name: "BoardListHomeNewsLayout",
  mixins: [imageOption],
  components: {},
  inject: [],
  provide() {
    return {}
  },
  props: {
    boardData: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {}
  },
  beforeRouterEnter() {
  },
  created() {
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {
    returnImage(board) {
      return `${board.NoticeFile.MobileFile[0].org_url}?${this.setImageOptions(650, 318, 'jpg')}`;
    },
    goDetail(idx) {
      this.$router.push(`/news/${idx}`)
    },
  },
  watch: {},
}
</script>

<style scoped>

</style>
